module.exports = __webpack_public_path__ + "img/ff-viewer.f60d8537.jpg";